import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  projectNameValue = new BehaviorSubject(this.projectName);

  constructor(public rest: RestService) { }

  set projectName(value) {
    this.projectNameValue.next(value);
    localStorage.setItem('projectName', value);
  }

  get projectName() {
    return localStorage.getItem('projectName');
  }

  public getItems() {
    return this.rest.get('getprojects', null, null);
  }

  public getArtifactsByProjectId(projectId) {
    return this.rest.get('getArtifactsByProjectId', projectId);
  }

  public getCodeReviewReportsDataByProjectId(projectId): any {
    return this.rest.get("getCodeReviewReportsDataByProjectId", projectId);
  }

  public getArtifactFromProject(projectId, artifactId, artifactType) {
    switch (artifactType) {
      case 'suite':
        return this.getProjectSuite(projectId, artifactId);
      case 'feature':
        return this.getProjectFeature(projectId, artifactId);
      case 'scenario':
        return this.getProjectScenario(projectId, artifactId);
      case 'step':
        return this.getProjectStep(projectId, artifactId);
    }
  }

  public getProjectSuite(projectId, artifactId) {
    return this.rest.get('projectSuite', projectId, artifactId);
  }

  public getProjectSuites(projectId) {
    return this.rest.get('projectSuites', projectId);
  }

  public getProjectFeature(projectId, artifactId) {
    return this.rest.get('projectFeature', projectId, artifactId);
  }

  public getProjectScenario(projectId, artifactId) {
    return this.rest.get('projectScenario', projectId, artifactId);
  }

  public getProjectStep(projectId, artifactId) {
    return this.rest.get('projectStep', projectId, artifactId);
  }

  public createProject(projectName: string, licenseId: string) {
    return this.rest.post('addproject', { project: { name: projectName }, licenseId: licenseId });
  }

  public updateProject(data) {
    return this.rest.post('updateproject', data);
  }
  public deleteProject(data) {
    return this.rest.post('deleteproject', data);
  }

  public getProjectManagementTypesForUser() {
    return this.rest.get('getProjectManagementTypesForUser', null);
  }

  public isStepNameAvailable(projectIdDb2, stepName) {
    return this.rest.get('isStepNameAvailable', projectIdDb2, stepName);
  }

  public getProjectMappingByProjectId(projectId: string) {
    return this.rest.get('getProjectMappingByProjectId', projectId);
  }
}
